<script setup lang="ts">
/**
 * How a queued thing starts — Manual, Ready, Under or Wastage
 * (shared/startMode.ts) — as one dropdown. `titles` says, per choice, what that choice does here; the one picked
 * is the dropdown's tooltip. Clicks and Enter stop here, so a row it sits in
 * does not open its menu as well.
 */
import { START_MODES, type StartMode } from "../lib/startMode.js";

const mode = defineModel<StartMode>({ required: true });
defineProps<{
  titles: Record<StartMode, string>;
  label: string;
  disabled?: boolean;
  /** Choices not offered here (a repo's start limit has no Manual). */
  without?: readonly StartMode[];
}>();
</script>

<template>
  <select
    v-model="mode"
    class="start-mode"
    :class="`start-mode-${mode}`"
    :title="titles[mode]"
    :aria-label="label"
    :disabled="disabled"
    @click.stop
    @pointerdown.stop
    @keydown.enter.stop
  >
    <option v-for="m in START_MODES.filter((o) => !without?.includes(o.value))" :key="m.value" :value="m.value" :title="titles[m.value]">{{ m.label }}</option>
  </select>
</template>
